import { useMemo } from "react"
import PropTypes from "prop-types"
import { TextField, Autocomplete } from "@mui/material"
import { reduce, map } from "lodash"
import { CURRENCY } from "helpers/shapes"

function makeSupportedCurrencyLabels(supportedCurrencies) {
  return reduce(supportedCurrencies, (result, currency) => ({
    ...result,
    [currency.id]: `${currency.name} (${currency.id})`,
  }), {})
}

function CurrencySelector({
  supportedCurrencies,
  value,
  onChange,
  onKeyPress,
  error,
}) {
  const supportedCurrencyIds = useMemo(() => map(supportedCurrencies, "id"), [supportedCurrencies])
  const supportedCurrencyLabels = useMemo(() => makeSupportedCurrencyLabels(supportedCurrencies), [supportedCurrencies])

  return <Autocomplete
    id="currency-selector"
    options={supportedCurrencyIds}
    value={value}
    getOptionLabel={(option) => supportedCurrencyLabels[option]}
    isOptionEqualToValue={(option, value) => option === value}
    onChange={onChange}
    renderInput={(params) => <TextField
      variant="standard"
      {...params}
      label="Select Currency"
      onKeyDown={onKeyPress}
      error={error}
    />}
  />
}

CurrencySelector.propTypes = {
  value: PropTypes.string,
  supportedCurrencies: PropTypes.arrayOf(CURRENCY),
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  error: PropTypes.bool,
}

export default CurrencySelector
